import { Box, TextField, Typography, Divider, Grid } from '@mui/material';
import { useFormikContext } from 'formik';
import React, { useEffect } from 'react';
import useResponsive from '../../../../../../Hooks/useResponsive';
import dayjs from 'dayjs';

const Step6PeriodConfiguration = () => {
  const smUp = useResponsive('up', 'sm');
  const mdUp = useResponsive('up', 'md');
  const { values, setFieldValue } = useFormikContext();

  const handleDateChange = (path) => (e) => {
    setFieldValue(path, dayjs(e.target.value).format('YYYY-MM-DD'));
  };

  return (
    <Box display="flex" flexDirection="column" gap={4}>
      <Typography variant="h6">Period Configuration</Typography>
      <Divider />

      {/* Process Period */}

      <Typography fontWeight="bold">Process Period</Typography>
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexWrap: smUp ? 'nowrap' : 'wrap',
          flexDirection: 'row',
        }}
      >
        <TextField
          size="small"
          fullWidth
          type="date"
          label="Start Date"
          InputLabelProps={{ shrink: true }}
          value={values.periodConfiguration.processPeriod.startDate}
          onChange={handleDateChange('periodConfiguration.processPeriod.startDate')}
        />

        <TextField
          size="small"
          fullWidth
          type="date"
          label="End Date"
          InputLabelProps={{ shrink: true }}
          value={values.periodConfiguration.processPeriod.endDate}
          onChange={handleDateChange('periodConfiguration.processPeriod.endDate')}
        />
      </Box>

      {/* Self Appraisal Period */}

      <Typography fontWeight="bold">Self Appraisal Period</Typography>
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexWrap: smUp ? 'nowrap' : 'wrap',
          flexDirection: 'row',
        }}
      >
        {' '}
        <TextField
          size="small"
          fullWidth
          type="date"
          label="Start Date"
          InputLabelProps={{ shrink: true }}
          value={values.periodConfiguration.selfAppraisalPeriod.startDate}
          onChange={handleDateChange('periodConfiguration.selfAppraisalPeriod.startDate')}
        />
        <TextField
          size="small"
          fullWidth
          type="date"
          label="End Date"
          InputLabelProps={{ shrink: true }}
          value={values.periodConfiguration.selfAppraisalPeriod.endDate}
          onChange={handleDateChange('periodConfiguration.selfAppraisalPeriod.endDate')}
        />
      </Box>

      {/* Manager Review Period */}

      <Typography fontWeight="bold">Manager Review Period</Typography>

      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexWrap: smUp ? 'nowrap' : 'wrap',
          flexDirection: 'row',
        }}
      >
        <TextField
          size="small"
          fullWidth
          type="date"
          label="Start Date"
          InputLabelProps={{ shrink: true }}
          value={values.periodConfiguration.managerReviewPeriod.startDate}
          onChange={handleDateChange('periodConfiguration.managerReviewPeriod.startDate')}
        />

        <TextField
          size="small"
          fullWidth
          type="date"
          label="End Date"
          InputLabelProps={{ shrink: true }}
          value={values.periodConfiguration.managerReviewPeriod.endDate}
          onChange={handleDateChange('periodConfiguration.managerReviewPeriod.endDate')}
        />
      </Box>

      {/* Rating Publish Period */}

      {/* <Typography fontWeight="bold">Rating Publish Period</Typography>
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexWrap: smUp ? 'nowrap' : 'wrap',
          flexDirection: 'row',
        }}
      >
        <TextField
          size="small"
          fullWidth
          type="date"
          label="Start Date"
          InputLabelProps={{ shrink: true }}
          value={values.periodConfiguration.ratingPublishPeriod.startDate}
          onChange={handleDateChange('periodConfiguration.ratingPublishPeriod.startDate')}
        />

        <TextField
          size="small"
          fullWidth
          type="date"
          label="End Date"
          InputLabelProps={{ shrink: true }}
          value={values.periodConfiguration.ratingPublishPeriod.endDate}
          onChange={handleDateChange('periodConfiguration.ratingPublishPeriod.endDate')}
        />
      </Box> */}

      {/* Feedback Period */}

      {/* <Typography fontWeight="bold">Feedback Period</Typography>
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexWrap: smUp ? 'nowrap' : 'wrap',
          flexDirection: 'row',
        }}
      >
        {' '}
        <TextField
          size="small"
          fullWidth
          type="date"
          label="Start Date"
          InputLabelProps={{ shrink: true }}
          value={values.periodConfiguration.feedBackPeriod.startDate}
          onChange={handleDateChange('periodConfiguration.feedBackPeriod.startDate')}
        />
        <TextField
          size="small"
          fullWidth
          type="date"
          label="End Date"
          InputLabelProps={{ shrink: true }}
          value={values.periodConfiguration.feedBackPeriod.endDate}
          onChange={handleDateChange('periodConfiguration.feedBackPeriod.endDate')}
        />
      </Box> */}

      {/* Publish Date */}

      <Typography fontWeight="bold">Final Publish Date</Typography>

      <TextField
        size="small"
        fullWidth
        type="date"
        label="Publish Date"
        InputLabelProps={{ shrink: true }}
        value={values.periodConfiguration.publishDate}
        onChange={handleDateChange('periodConfiguration.publishDate')}
      />
    </Box>
  );
};

export default Step6PeriodConfiguration;
